<template>
  <div class="look-image-container">
    <el-image class="image" :src="srcPath" lazy :preview-src-list="[srcPath]" />
    <div class="look-box">
      <div class="look-img">
        <div class="img-box">
          <img
            class="look"
            src="@/assets/icon_look_img.png"
            @click="onLookClick"
          />
          <img
            class="delete"
            src="@/assets/icon_look_img_del.png"
            @click="onDeleteClick"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LookImage",
  props: {
    srcPath: {
      type: String,
      default: "",
    },
  },
  methods: {
    //查看大图
    onLookClick() {
      const domImage = document.querySelector(".el-image__preview");
      if (!domImage) {
        return;
      }
      domImage.click();
      this.$nextTick(() => {
        const imgBox = document.querySelector(".el-image-viewer__img");
        if (imgBox) {
          imgBox.src = this.srcPath;
        }
      });
    },
    //删除
    onDeleteClick() {
      this.$emit("onDeleteClick");
    },
  },
};
</script>
<style lang="scss" scoped>
.look-image-container {
  width: 60px;
  height: 60px;
  position: relative;
  margin-right: 10px;
  .image {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
  .look-box {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    .look-img {
      text-align: center;
      height: 100%;
      width: 100%;
      display: none;
      border-radius: 4px;
      background-color: rgba($color: #000000, $alpha: 0.4);
      .img-box {
        display: flex;
        align-items: center;
        justify-content: center;
        .look {
          cursor: pointer;
          margin-top: 20px;
          display: inline-block;
          width: 16px;
        }
        .delete {
          cursor: pointer;
          margin-top: 18px;
          margin-left: 10px;
          display: inline-block;
          width: 16px;
        }
      }
    }
  }
  .look-box:hover {
    .look-img {
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LookImage/index.vue